import sdk from '@trazi/opt-out/sdk/node';
import bugsnag from '@bugsnag/js';

/**
 * Returns a formatted list of names from the opt-out SDK.
 * Names are often delimited by a space, dash, or pipe
 * @param {string} delimiter
 * @returns {array}
 */
const getOptOutNames = async (delimiter = ' ', $bugsnag = {}) => {
  // Use localhost to bypass external proxies (Cloudflare/Radware)
  const serverPort = process.env.WEBPORT || process.env.PORT || 8008;
  const optOutSDK = sdk(`http://localhost:${serverPort}/api`);
  try {
    // Body must be null: the SDK writes GET bodies without Content-Length, which corrupts the keep-alive socket
    const response = await optOutSDK.LocalDomain.getIndexList(
      null,
      `${process.env.WEBSITE}.com`
    );

    // Fallback for if response fails to prevent entire page from crashing
    if (!Array.isArray(response)) {
      const website = process.env.WEBSITE
        ? process.env.WEBSITE.toUpperCase()
        : process.env.PREFIX;
      $bugsnag?.notify(
        `${website}: optOutSDK.LocalDomain.getIndexList Response Is Not An Array`
      );

      return [];
    }

    return response.map(
      name =>
        `${name.firstname.toLowerCase()}${delimiter}${name.lastname.toLowerCase()}`
    );
  } catch (error) {
    console.log(error);
  }
};

export default getOptOutNames;
